export enum USER_ROLES {
    ADMIN = "ADMIN",
    CASHIER = "CASHIER",
    SALES_REPRESENTATIVE = "SALES_REPRESENTATIVE",
    MANAGER = "MANAGER",
    WAITER = "WAITER"
  }

export interface UserType {
    _id?:string;
    name: string;
    userId: string;
    password: string;
    pin: number;
    role: USER_ROLES;
  }